import ExcelJS from "exceljs";
import { HeaderStyle, RowStyle } from "../constants/DataSourceExcelStyling";
import { convertToDS } from '../functions/DataSource';
import { EditableDataSource } from '../types/Data/DataSource';
import Upload from "./Icons/Upload";

interface ExportToExcelButtonProp {
    onClick?: () => void | undefined,
    ds?: EditableDataSource | undefined,
};

/**
 * More information on excel formatting and data types can be found here:
 * http://officeopenxml.com/anatomyofOOXML-xlsx.php
 */

const ExportToExcelButton = ({ ds, onClick }: ExportToExcelButtonProp) => {
    const getButtonColoring = () => {
        return 'btn-blattnerblue';
    };

    const xlsxWriteFile = async () => {
        if (!ds) {
            return;
        }

        const newDataSource = convertToDS(ds);
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Rows");

        // Add header row with styling
        const headerRow = worksheet.addRow(newDataSource.headers.map(h => h.name));
        headerRow.eachCell(cell => {
            Object.assign(cell, { style: HeaderStyle });
        });

        // Add data rows with styling
        newDataSource.rows.forEach(row => {
            const dataRow = worksheet.addRow(row);
            dataRow.eachCell(cell => {
                Object.assign(cell, { style: RowStyle });
            });
        });

        const timestamp = new Date().getTime();
        const fileName = `${ds.name}-${timestamp}.xlsx`;

        // Write file and trigger download
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        a.click();
        URL.revokeObjectURL(url);
    };

    const handleOnClick = () => {
        xlsxWriteFile();

        if(onClick) {
            onClick();
        }
    };

    return (
        <div>
            <button
                type='button'
                className={`btn data-source-btn ${getButtonColoring()}`}
                onClick={handleOnClick}
            >
                Export
                &nbsp;
                <Upload color="white" />
            </button>
        </div>
    );
}

export default ExportToExcelButton;